import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningItem} from '@domain/planning/planning-item';
import {find, findIndex, forEach, isEqual, remove} from 'lodash-es';
import {RescheduleOverlappingItemsCommand} from '../reschedule-overlapping-items/reschedule-overlapping-items-command';
import {RescheduleItemsParameters} from './reschedule-items-parameters';

export class RescheduleItemsCommand implements Command<RescheduleItemsParameters, CalendarItemGroup[]> {
  public execute(commandArgs: RescheduleItemsParameters): CalendarItemGroup[] {
    const {planningItem, sourceMachine, destinationGroupedCalendarItem, groupedCalendarItems} = commandArgs;

    const groupedCalendarItemsToBeUpdated: CalendarItemGroup[] = [destinationGroupedCalendarItem];

    new RescheduleOverlappingItemsCommand().execute({planningItem, groupedCalendarItem: destinationGroupedCalendarItem});

    const droppedOnDifferentMachine = !isEqual(destinationGroupedCalendarItem.machineId, sourceMachine.id);
    if (droppedOnDifferentMachine) {
      const sourceGroupedCalendarItem: CalendarItemGroup = find(groupedCalendarItems, {machineId: sourceMachine.id});
      remove(sourceGroupedCalendarItem.items as PlanningItem[], {uniqueId: planningItem.uniqueId});
      groupedCalendarItemsToBeUpdated.push(sourceGroupedCalendarItem);
      destinationGroupedCalendarItem.items.push(planningItem);
    } else {
      const itemIndex: number = findIndex(destinationGroupedCalendarItem.items as PlanningItem[], {uniqueId: planningItem.uniqueId});
      destinationGroupedCalendarItem.items[itemIndex] = planningItem;
    }

    forEach(groupedCalendarItemsToBeUpdated, (groupedCalendarItemToBeUpdated: CalendarItemGroup) => {
      forEach(groupedCalendarItems, (groupedCalendarItem: CalendarItemGroup, index: number) => {
        if (isEqual(groupedCalendarItemToBeUpdated.machineId, groupedCalendarItem.machineId)) {
          groupedCalendarItems[index] = groupedCalendarItemToBeUpdated;
          return false;
        }
      });
    });

    return groupedCalendarItems;
  }
}
